import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LocalText from '../../../localization/local_text';

import NavData from '../../../config/data/nav/nav_data.json';
import LogoFooter from '../../../assets/images/common/footer_logo.svg';
import './css/common_footer.scss';
import useContent from '@/localization/data_export';

const CommonFooter = () => {
  const { mode } = useSelector((state) => state);
  const anchorTitle = useContent(['global', 'anchor', 'title']);
  const location = useLocation();

  const nav = NavData;

  const isRadioPage = location.pathname.split('/')[1] === 'radio';
  const isNewsPage = location.pathname.split('/')[1] === 'news';
  const isBusinessPage = location.pathname.split('/')[1] === 'business';

  return (
    <footer id="nav-footer" className={`page-footer${isRadioPage ? ' radio-layout' : ''}`}>
      <div className="page-footer-section page-footer-section--nav-row-1">
        <ul className="page-footer-list">
          <li>
            <a
              href={`https://company.arirang.com/?lang=${mode}`}
              target={'_blank'}
              className="page-footer-link"
              rel="noreferrer"
              title={anchorTitle}
            >
              <LocalText txt={'footer_about'} />
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/join/watch?subPage=watch`}
              target="_blank"
              className="page-footer-link"
              rel="noreferrer"
              title={anchorTitle}
            >
              <LocalText txt={'footer_watch'} />
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/join/watch?subPage=listen`}
              target="_blank"
              className="page-footer-link"
              rel="noreferrer"
              title={anchorTitle}
            >
              <LocalText txt={'footer_listen'} />
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/join/cs`}
              target="_blank"
              className="page-footer-link"
              rel="noreferrer"
              title={anchorTitle}
            >
              <LocalText txt={'footer_faq'} />
            </a>
          </li>
          {isNewsPage && (
            <li>
              <Link className="page-footer-link" to={nav['NEWS_REPORTER'].path} title={anchorTitle}>
                <LocalText txt={'footer_repoerter'} />
              </Link>
            </li>
          )}
        </ul>
        <div className="page-footer-business">
          <button type="button" className="business-button">
            <LocalText txt={'footer_business'} />
          </button>
          <ul className="business-list">
            <li className={`business-item${isBusinessPage ? ' active' : ''}`}>
              <Link className="business-link" to={nav['BUSINESS_GLOBAL'].path} title={anchorTitle}>
                {mode === 'en' ? 'Distribution' : '배포'}
              </Link>
            </li>
            <li className="business-item">
              <a
                className="business-link"
                href={`https://company.arirang.com/business/tvad/?lang=${mode}`}
                target="_blank"
                rel="noreferrer"
                title={anchorTitle}
              >
                {mode === 'en' ? 'Advertisement' : '광고'}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <span className="page-footer-line" />
      <div className="page-footer-section page-footer-section--nav-row-2">
        <ul className="page-footer-list">
          <li>
            <a
              href={`https://company.arirang.com/policy/personal/?lang=${mode}`}
              className="page-footer-link page-footer-link--personal-policy"
              target="_blank"
              rel="noreferrer"
              title={anchorTitle}
            >
              {mode === 'en' ? 'Privacy Policy' : '개인정보처리방침'}
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/policy/agree/?lang=${mode}`}
              className="page-footer-link"
              target="_blank"
              rel="noreferrer"
              title={anchorTitle}
            >
              {mode === 'en' ? 'Terms of Use' : '이용약관'}
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/policy/process/?lang=${mode}`}
              className="page-footer-link"
              target="_blank"
              rel="noreferrer"
              title={anchorTitle}
            >
              {mode === 'en' ? 'Video information policy' : '영상정보 운영관리방침'}
            </a>
          </li>
          <li>
            <a
              href={`https://company.arirang.com/policy/copyright/?lang=${mode}`}
              className="page-footer-link"
              target="_blank"
              rel="noreferrer"
              title={anchorTitle}
            >
              {mode === 'en' ? 'Copyright Policy' : '저작권 정책'}
            </a>
          </li>
        </ul>
      </div>

      <div className="page-footer-section page-footer-section--arirang">
        <div className="page-footer-address">
          <address>
            <p>Arirang Tower, 2351,Nambusunhwan-ro,Seocho-gu,Seoul,06713,Rep.of KOREA</p>
            <a href="tel:82234755000">82-8-3475-5000</a>
            <a href="mailto:help@arirang.com">E-mail : help@arirang.com</a>
          </address>
          <p>The Korea International Broadcasting Foundation. All Rights Reserved.</p>
        </div>
        <div className="page-footer-follow">
          <h3 className="page-footer-follow__title">FOLLOW ARIRANG</h3>
          <ul className="page-footer-follow__sns-list">
            <li>
              <a
                href="https://www.facebook.com/arirangtv/"
                target="_blank"
                rel="noreferrer"
                className="icon icon--facebook"
                title={anchorTitle}
              >
                <span className="screen-reader">
                  {mode === 'en' ? 'Link to Arirang World facebook_New window opened' : '아리랑 페이스북 바로가기'}
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/user/arirang"
                target="_blank"
                rel="noreferrer"
                className="icon icon--youtube"
                title={anchorTitle}
              >
                <span className="screen-reader">
                  {mode === 'en' ? 'Link to Arirang TV youtube_New window opened' : '아리랑 유튜브 바로가기'}
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/arirangworld/"
                target="_blank"
                rel="noreferrer"
                className="icon icon--instagram"
                title={anchorTitle}
              >
                <span className="screen-reader">
                  {mode === 'en' ? 'Link to Arirang Instagram_New window opened' : '아리랑 인스타그램 바로가기'}
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/arirangworld"
                target="_blank"
                rel="noreferrer"
                className="icon icon--twitter"
                title={anchorTitle}
              >
                <span className="screen-reader">
                  {mode === 'en' ? 'Link to Arirang World X_New window opened' : '아리랑 X 바로가기'}
                </span>
              </a>
            </li>
          </ul>
          <a
            className="kogl_mark"
            href="https://www.kogl.or.kr/index.do"
            target="_blank"
            rel="noreferrer"
            title={anchorTitle}
          >
            <img src={require('../../../assets/images/common/kogl_mark_eng.svg').default} alt="" />
          </a>
        </div>
        <img src={LogoFooter} alt="Excellent family-friendly institution" className="page-footer-logo" />
      </div>
    </footer>
  );
};

export default CommonFooter;
